import {Component, OnInit} from '@angular/core';
import {IonicModule, ModalController} from '@ionic/angular';
import {NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ToastService} from '../../services/toast.service';
import {ArbameService} from '../../services/arbame.service';
import {CaptchaModule} from '../captcha/captcha.module';
import { SubService } from 'src/app/services/sub.service';

@Component({
  selector: 'app-join-trader',
  templateUrl: './join-trader.component.html',
  styleUrls: ['./join-trader.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgIf,
    FormsModule,
    CaptchaModule,
  ],
})
export class JoinTraderComponent implements OnInit {
  stage = 'register';
  firstName: any;
  lastName: any;
  email: any;
  phoneNumber: any;
  companyName: any;
  companyWebsite: any;
  type: any;
  message: any;

  firstNameError: any;
  lastNameError: any;
  emailError: any;
  phoneNumberError: any;
  companyNameError: any;
  companyWebsiteError: any;
  typeError: any;
  messageError: any;

  constructor(private ts: ToastService, private aService: ArbameService, private modalCtrl: ModalController, private sub: SubService) {
  }

  ngOnInit() {
  }

  SendRegistrationData() {
    let hasError = false;
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!this.firstName || this.firstName.trim() === '') {
      this.firstNameError = 'Required';
      hasError = true;
    } else if (this.firstName.trim().length < 2) {
      this.firstNameError = 'Too short';
      hasError = true;
    }
    if (!this.lastName || this.lastName.trim() === '') {
      this.lastNameError = 'Required';
      hasError = true;
    } else if (this.lastName.trim().length < 2) {
      this.lastNameError = 'Too short';
      hasError = true;
    }
    if (!this.email || this.email.trim() === '') {
      this.emailError = 'Required';
      hasError = true;
    } else if (this.email.trim().length < 2) {
      this.emailError = 'Too short';
      hasError = true;
    } else if (!pattern.test(this.email) && this.email !== '') {
      this.emailError = 'Invalid Email';
      hasError = true;
    }

    if (!this.phoneNumber || this.phoneNumber.trim() === '') {
      this.phoneNumberError = 'Required';
      hasError = true;
    } else if (this.phoneNumber.trim().length < 2) {
      this.phoneNumberError = 'Too short';
      hasError = true;
    }

    if (!this.companyName || this.companyName.trim() === '') {
      this.companyNameError = 'Required';
      hasError = true;
    } else if (this.companyName.trim().length < 2) {
      this.companyNameError = 'Too short';
      hasError = true;
    }
    if (!this.type) {
      this.typeError = 'Required';
      hasError = true;
    }
    if (!this.message || this.message.trim() === '') {
      this.messageError = 'Required';
      hasError = true;
    } else if (this.message.trim().length < 2) {
      this.messageError = 'Too short';
      hasError = true;
    }
    if (hasError) {
      return;
    }
    const fd = new FormData();
    fd.append('first_name', this.firstName);
    fd.append('last_name', this.lastName);
    fd.append('email', this.email);
    fd.append('phone_number', this.phoneNumber);
    fd.append('message', this.message);
    fd.append('company_name', this.companyName);
    fd.append('company_website', this.companyWebsite);
    fd.append('role', this.type);
    // fd.append('key', this.captcha.key);
    // fd.append('captcha', this.captchaInput);
    this.loading = true;
    this.aService.registerRequest(fd).subscribe((data) => {
      this.stage = 'result';
      this.loading = false;
    },error => {
      this.recaptchaReload=true
      this.loading = false;
      setTimeout(()=>{
        this.recaptchaReload=false

      },100)
      if (error.error.message==='email use before'){
        this.ts.ErrorToast('Already registered')
        return
      }
      if (error.error.message==='email use before'){
        this.ts.ErrorToast('Already registered')
        return
      }

      this.ts.ErrorToast(error.error.message)
    });


  }

  loading;
  captcha;
  recaptchaReload;

  CaptchaReceived($event) {
    this.captcha = $event;
  }

  registerCaptchaError;
  forgetCaptchaError;
  captchaInput;
  captchaError: any;

  captchaUserInputChanged($event: any) {

    this.captchaInput = $event;
    this.registerCaptchaError = null;
    this.forgetCaptchaError = null;
  }

  dimiss() {
    this.modalCtrl.dismiss();
  }
  openRegister() {
    this.dimiss();
    setTimeout(() => {
      this.sub.openAuth.next(true);
    }, 300);
  }
}
